import React from "react";
import { useSettings } from "@/components/layout/PublicLayout";
import Reveal from "@/components/shared/Reveal";
import Seo from "@/components/shared/Seo";
import { Mail, MapPin, Linkedin } from "lucide-react";

const APropos = () => {
  const settings = useSettings();
  const about = settings?.about || {};
  const contact = settings?.contact || {};
  return (
    <>
      <Seo title="À propos & contact — FACADES2build" description={about.text} />
      <section className="bg-f2b-black pt-40 pb-20">
        <div className="f2b-container max-w-3xl">
          <Reveal><p className="f2b-kicker text-f2b-cyan mb-4">À propos</p></Reveal>
          <Reveal delay={0.08}><h1 className="font-display font-bold text-white text-4xl md:text-6xl leading-tight">{about.title || "FACADES2build n'est pas un salon."}</h1></Reveal>
          <Reveal delay={0.16}><p className="f2b-lead text-white/75 text-xl md:text-2xl mt-8 leading-relaxed">{about.text}</p></Reveal>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="f2b-container grid md:grid-cols-2 gap-12">
          {(about.positioning || about.buildinglab_url) && (
            <Reveal>
              {about.positioning && (
                <>
                  <h2 className="font-display font-bold text-f2b-black text-3xl mb-6">Notre positionnement</h2>
                  <p className="text-f2b-text/80 leading-relaxed whitespace-pre-line">{about.positioning}</p>
                </>
              )}
              {about.buildinglab_url && (
                <a href={about.buildinglab_url} target="_blank" rel="noreferrer" className="inline-block mt-8 text-f2b-cyan f2b-link-underline" data-testid="about-buildinglab-link">
                  {about.buildinglab_label || "Une initiative BuildingLab"} →
                </a>
              )}
            </Reveal>
          )}
          <Reveal delay={0.1}>
            <div className="bg-f2b-light p-8">
              <h2 className="f2b-kicker text-f2b-gray mb-6">Contact</h2>
              <ul className="space-y-4 text-f2b-text">
                <li className="flex items-center gap-3"><Mail size={18} className="text-f2b-cyan" /><a href={`mailto:${contact.email}`} className="hover:text-f2b-cyan">{contact.email || "contact@facades2build.com"}</a></li>
                <li className="flex items-center gap-3"><MapPin size={18} className="text-f2b-cyan" />{contact.address || "89 rue de Richelieu, Paris"}</li>
                {contact.linkedin && <li className="flex items-center gap-3"><Linkedin size={18} className="text-f2b-cyan" /><a href={contact.linkedin} target="_blank" rel="noreferrer" className="hover:text-f2b-cyan">LinkedIn</a></li>}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
};

export default APropos;
